import { Body4, Button } from '@cointracker/styleguide/src/LoggedIn';
import { useTranslation } from 'react-i18next';
interface GetInSyncContentProps {
  onClickPrimary: () => void;
  automaticallySyncedWalletsCount: number;
  syncIssuesCount: number;
}

export const GetInSyncContent = ({
  onClickPrimary,
  automaticallySyncedWalletsCount,
  syncIssuesCount,
}: GetInSyncContentProps) => {
  const { t } = useTranslation();
  return (
    <div className="flex flex-col gap-16 pt-16">
      <Body4>
        {t('navigation.tax_readiness.sheet.get_in_sync_content.description')}
      </Body4>
      <div className="flex flex-row justify-between">
        <Body4>
          {t(
            'navigation.tax_readiness.sheet.get_in_sync_content.wallets_and_exchanges_to_re_authenticate',
          )}
        </Body4>
        <Body4>{syncIssuesCount}</Body4>
      </div>
      <div className="flex flex-row justify-between">
        <Body4>
          {t(
            'navigation.tax_readiness.sheet.get_in_sync_content.automatically_synced',
          )}
        </Body4>
        <Body4>{automaticallySyncedWalletsCount}</Body4>
      </div>
      <div className="flex gap-10">
        <Button size="small" variant="highEmphasis" onClick={onClickPrimary}>
          {t('navigation.tax_readiness.sheet.get_in_sync_content.button')}
        </Button>
      </div>
    </div>
  );
};
